import { createFileRoute, useNavigate } from '@tanstack/react-router';
import PeoplePage from '@/pages/PeoplePage.jsx';

const str = (v) => (typeof v === 'string' && v.trim() ? v : undefined);

function PeopleRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onSearchChange = (patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
  return <PeoplePage search={search} onSearchChange={onSearchChange} />;
}

export const Route = createFileRoute('/people/')({
  validateSearch: (s) => ({
    industry: str(s.industry),
    country: str(s.country),
    q: str(s.q),
    page: Number(s.page) > 1 ? Math.floor(Number(s.page)) : undefined,
  }),
  component: PeopleRoute,
});
